export default function ManualUsuario() {
    return window.location.replace(
        'https://docs.farolsoftware.com.br/d/ponto-agil',
    ) as any
}
